module.exports = __webpack_public_path__ + "img/コンピュータのしくみI_4_1_3.df2ecc23.png";